<template>
  <div class="layout-container">
    <template v-if="!filterMenuConfig">
      <div class="">加在中</div>
    </template>
    <template v-else>
      <!-- 第一行：系统图标 + 一级菜单 + 下拉框 -->
      <el-header class="layout-header" height="40px">
        <div class="header-content">
          <!-- 左侧：系统图标 -->
          <div class="header-left">
            <div class="system-logo">
              <i class="el-icon-s-platform"></i>
            </div>
          </div>

          <!-- 中间：一级菜单导航 -->
          <div class="header-center">
            <el-menu
              :default-active="activeMenu"
              mode="horizontal"
              @select="handleMenuSelect"
              class="top-menu"
            >
              <el-menu-item
                v-for="menu in filterMenuConfig"
                :key="menu.name"
                :index="menu.id"
              >
                {{ menu.name }}
              </el-menu-item>
            </el-menu>
          </div>

          <!-- 右侧：下拉框 -->
          <div class="header-right" v-if="!isManager">
            <label>项目名称：</label>
            <el-select
              v-model="projectInfo"
              clearable
              placeholder="请选择"
              size="mini"
              @change="handleChangeProject"
            >
              <el-option
                v-for="item in options"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>

            <label class="lock-no">锁号：{{ lockNo }}</label>
          </div>
        </div>
      </el-header>

      <!-- 第二行：二级菜单 -->
      <div class="submenu-bar" v-if="filterCurrentSubMenus">
        <el-menu
          :default-active="activeSubMenu"
          mode="horizontal"
          @select="handleSubMenuSelect"
          class="submenu"
        >
          <el-menu-item
            v-for="subMenu in filterCurrentSubMenus"
            :key="subMenu.path"
            :index="subMenu.id"
          >
            {{ subMenu.name }}
          </el-menu-item>
        </el-menu>
        <div class="submenu-right">
          <!-- <el-button
            v-if="!$route.meta.hideSave"
            type="primary"
            size="mini"
            @click="save"
            >保存</el-button
          > -->
        </div>
      </div>

      <!-- 第三行：内容区域 -->
      <div class="layout-content">
        <router-view
          ref="routerView"
          @project-info-save="getProjectInfo"
          :projectId="projectInfo"
        />
      </div>
      <AI2Dialog v-if="!isManager" />
    </template>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import { sortRecords, dfsFn } from '@/utils/index.js'
import AI2Dialog from '@/components/AI2Dialog/index.vue'

export default {
  name: 'Layout',
  components: {
    AI2Dialog
  },
  data() {
    return {
      backupRoute: null,
      options: [],
      projectInfo: localStorage.getItem('currentProjectInfo'),
      lockNo: '123456789',
      filterMenuConfig: [],
      filterCurrentSubMenus: [],
      isManager: process.env.type === 'manager',

      activeMenu: '',
      activeSubMenu: ''
    }
  },

  computed: {
    ...mapState(['menuConfig'])
  },
  watch: {
    // 监听路由变化，更新菜单状态
    $route(to) {
      this.getCurrentRoute(to.path)
    }
  },
  created() {
    this.getBackupRoute()
  },
  methods: {
    async getBackupRoute() {
      let res
      if (process.env.type === 'manager') {
        res = {
          code: 200,
          data: [
            {
              id: 'platform-management',
              name: '平台管理',
              children: [
                {
                  id: 'user-management',
                  name: '平台用户管理',
                  code: '/platform-management/user-management'
                },
                {
                  id: 'menu-management',
                  name: '菜单管理',
                  code: '/platform-management/menu-management'
                }
              ]
            }
          ]
        }
      } else {
        res = await this.$service.get('/sys-menu/list')
      }
      if (res?.code === 200) {
        const menus = []
        // 过滤掉已经删除的菜单
        for (const val of res.data) {
          const menu = { ...val, showFlag: true, children: [], id: val.id }

          for (const ele of val.children) {
            const obj = this.menuConfig.find(m => ele.code === m.path)
            if (obj) {
              menu.children.push({ ...obj, showFlag: true, ...ele })
            }
          }
          menu.children = sortRecords(menu.children)
          menus.push(menu)
        }
        this.init(sortRecords(menus))
      }
    },
    init(menu) {
      this.filterMenuConfig = menu

      const path = this.$route.path
      this.getCurrentRoute(path)
      if (process.env.type !== 'manager') {
        this.getProjectInfo()
      }
    },

    getCurrentRoute(path) {
      // 找到选中的一级路由
      let currentRouteOne = this.filterMenuConfig.find(e =>
        e.children?.some(child => child.path === path)
      )
      if (!currentRouteOne) currentRouteOne = this.filterMenuConfig[0]
      this.activeMenu = currentRouteOne.id

      // 找到选中的二级路由
      let currentRouteTwo = currentRouteOne.children.find(e => e.path === path)
      if (!currentRouteTwo) {
        currentRouteTwo = currentRouteOne.children[0]
        this.$router.replace(currentRouteTwo.path)
      }
      this.filterCurrentSubMenus = currentRouteOne.children
      this.activeSubMenu = currentRouteTwo.id
    },

    // 处理一级菜单选择
    handleMenuSelect(menuId) {
      this.activeMenu = menuId

      this.filterCurrentSubMenus =
        this.filterMenuConfig.find(m => m.id === menuId).children || []
      this.activeSubMenu = this.filterCurrentSubMenus[0].id
      this.navigatorToPage(this.filterCurrentSubMenus[0].path)
    },

    // 处理二级菜单选择
    handleSubMenuSelect(subMenuId) {
      this.activeSubMenu = subMenuId
      const subMenu = this.filterCurrentSubMenus.find(m => m.id === subMenuId)
      this.navigatorToPage(subMenu.path)
    },

    navigatorToPage(path) {
      if (path && this.$route.path !== path) {
        this.$router.push(path)
      }
    },

    async getProjectInfo() {
      const res = await this.$service.get('/project/list')
      if (res?.code === 200) {
        this.options = sortRecords(res.data)
      }
    },

    handleChangeProject() {
      localStorage.setItem('currentProjectInfo', this.projectInfo)
    },

    save() {
      // 方法1：通过ref获取router-view中的当前路由组件
      const routerView = this.$refs.routerView
      if (routerView.save) {
        routerView.save()
      } else {
        console.warn('未找到当前路由组件的save方法')
      }
    }
  }
}
</script>

<style lang="less" scoped>
.layout-container {
  height: 100vh;
  display: flex;
  flex-direction: column;
}

/* 第一行：系统图标 + 一级菜单 + 下拉框 */
.layout-header {
  height: 28px;
  background: #f2f2f2;
  color: #000;
  z-index: 1000;
  padding: 0;
  border-bottom: 1px solid #ccc;

  .header-content {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 16px;
  }

  .header-left {
    display: flex;
    align-items: center;

    .system-logo {
      width: 32px;
      height: 32px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #667eea;
      font-size: 16px;
      font-weight: bold;

      i {
        font-size: 20px;
      }
    }
  }

  .header-center {
    flex: 1;
    display: flex;
    justify-content: flex-start;

    .top-menu {
      background: unset;
      height: 100%;
      border: unset;

      .el-menu-item {
        height: 100%;
        margin: 0 2px;
        font-weight: 500;
        font-size: 14px;
        line-height: unset;
        border: unset;
        height: 32px;
        border-radius: 6px;
        display: flex;
        align-items: center;
        justify-self: unset;
        color: #000;
        padding: 0 12px;

        &:hover {
          background: #c4edff * 1.2;
        }

        &.is-active {
          border: unset;
          background: #c4edff;
        }
      }
    }
  }

  .header-right {
    display: flex;
    align-items: center;
    justify-content: flex-end;

    label {
      font-size: 14px;
      font-weight: 600;
    }

    .lock-no {
      margin-left: 16px;
    }

    .el-select {
      width: 300px;
      color: #000;

      ::v-deep .el-input__inner {
        color: unset;
      }
    }
  }
}

/* 第二行：二级菜单 */
.submenu-bar {
  height: 40px;
  display: flex;
  align-items: center;
  padding: 0 16px;
  background: #f2f2f2;
  color: #000;
  z-index: 1000;
  border-bottom: 1px solid #ccc;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .submenu {
    background: transparent;
    border-bottom: none;
    height: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: center;

    color: #000;

    .el-menu-item {
      height: 100%;
      margin: 0 2px;
      font-weight: 500;
      font-size: 14px;
      line-height: unset;
      border: unset;
      height: 32px;
      border-radius: 6px;
      display: flex;
      align-items: center;
      justify-self: unset;
      color: #000;
      padding: 0 12px;

      &:hover {
        background: #c4edff * 1.2;
      }

      &.is-active {
        border: unset;
        background: #c4edff;
      }
    }
  }

  .submenu-right {
    font-size: 14px;
    font-weight: 600;
  }
}

/* 第三行：内容区域 */
.layout-content {
  flex: 1;
  overflow-y: auto;
  background: #fff;
  padding: 12px 16px;
}
</style>
